module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "app",
      "light": ""
    }
  }, [_c('v-content', [_c('v-container', {
    staticClass: "registration-background",
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center white--text page-title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.uiState.pageTitle))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.uiState.pageSubtitle))])]), _vm._v(" "), _c('w-card', {
    staticClass: "elevation-4 registration-card"
  }, [_c('v-layout', {
    staticClass: "header-wrapper",
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "card-wrapper"
  }, [_c('w-card', {
    staticClass: "elevation-4"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": ""
    }
  })])], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "registration-content mt-3 mb-3"
  }, [_c('router-view', {
    staticClass: "pt-3"
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loading"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 70,
      "width": 7,
      "color": "blue"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center white--text mt-3"
  }, [_vm._v("\n            © Weview " + _vm._s(_vm.year) + "\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 555
// module chunks = 1